import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'components/Icon'
import { ResizeContext } from 'contexts/Resize'

import {
  Wrapper,
  Container,
  Header,
  Title,
  ButtonStyled,
  Description,
  YoutubeContainer,
} from './styles'
import YouTubeItem from './components/YoutubeItem'

export const BYoutube = ({ texts }) => {
  const { title, description, video, subscribe_text = 'Subscribe to our YouTube channel' } = texts
  const { tablet, mobile } = React.useContext(ResizeContext)

  const button = (
    <ButtonStyled
      variant={'outlined'}
      isDangerouslySet={false}
      href='https://www.youtube.com/@atlasbiomed7971'
      target='_blank'
      block={mobile}
      size={mobile ? 'mobile' : 'desktop'}
    >
      <Icon id={'youtube'} />
      <span dangerouslySetInnerHTML={{ __html: subscribe_text }} />
    </ButtonStyled>
  )

  return (
    <Wrapper>
      <Container>
        <Header>
          <Title
            weight={'medium'}
            size={['50/60', '50/60', '25/30']}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {!tablet && !mobile && button}
        </Header>

        <Description
          size={['22/30', '22/30', '16/25']}
          dangerouslySetInnerHTML={{ __html: description }}
        />

        <YoutubeContainer>
          {video.map(({ id, views }) => (
            <YouTubeItem
              key={id}
              videoId={id}
              views={views}
            />
          ))}
        </YoutubeContainer>

        {(tablet || mobile) && button}
      </Container>
    </Wrapper>
  )
}

BYoutube.propTypes = {
  texts: PropTypes.object.isRequired,
}
